import React from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "../entities/formTemplateDataType";
import { SubSectionComponent } from "../runtimeComponent/SubSectionComponent";
import { Heading1, colour } from "../theme";
import { CMADashboardComponent } from "../runtimeComponent/subComponent/cma/CMADashboardComponent";
import { CMAReviewComponent } from "../runtimeComponent/subComponent/cma/CMAReviewComponent";
import { SuccessAlertComponent } from "../runtimeComponent/odsCalloutBox/SuccessAlertComponent";
import { parseJson, stringifyJson } from "../utilities/JsonUtils";
import CMAUtils from "../utilities/CMAUtils";
import { TemplateStatus, TOKEN_TYPE } from "../entities/Constants";
import SessionStorageService from "../services/SessionStorageService";
import URLUtils from "../utilities/URLUtils";
import axios from "axios";
import * as CircularJSON from 'circular-json';
import { formatDateCustom } from "../utilities/DateUtils";
import { Toast } from 'primereact/toast';
import styled from "styled-components";
import { ErrorAlertsComponent } from "../runtimeComponent/odsCalloutBox/ErrorAlertsComponent";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    callback: (programContainer: ProgramContainer) => void;
    callbackValidate?: (errors: any) => void;
}

interface State {
    stepperIndex: number;
    fromReview: boolean;
    showError: boolean;
    showConfirmation: boolean;
    initialSubsec: FormSubSections;
    subsecBool: boolean;
    CSDAssessments: any[];
    CSDSearchString: string;
    CSDSortByAlphabet: boolean;
    assessmentListOption: string;
    isProhibited:  boolean;
}

const CSDTableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: ${colour.palette.greyscale70};
    padding: 18px 16px 18px 24px;
`;

const StyledHeaderButton = styled.button`
    color: ${colour.palette.white};
    margin: 0;
    
    &:hover {
        color: ${colour.palette.white};
        background-color: ${colour.palette.greyscale60};
    }
`;

export const updateFaviconForApp = (programContainer: ProgramContainer) => {
    console.log('updateFaviconForApp called with:', programContainer.AppTitle);

    (window as any).programContainer = programContainer;

    const appTitle = programContainer.AppTitle?.en || programContainer.AppTitle?.fr || programContainer.Name;
    if (appTitle && document.title !== appTitle) {
        document.title = appTitle;
    }

    if (typeof (window as any).updateFavicon === 'function') {
        (window as any).updateFavicon();
    }

    window.dispatchEvent(new CustomEvent('programContainerLoaded'));
};

export class CMAFormComponent extends React.Component<Props, State> {
    timer: NodeJS.Timeout;
    growl: Toast;
    errorAlertRef: React.RefObject<ErrorAlertsComponent>;

    constructor(props) {
        super(props);
        this.errorAlertRef = React.createRef();
        this.state = {
            stepperIndex: 0,
            fromReview: false,
            showError: false,
            showConfirmation: false,
            initialSubsec: null,
            subsecBool: true,
            CSDAssessments: [],
            CSDSearchString: '',
            CSDSortByAlphabet: false,
            assessmentListOption: "All",
            isProhibited: false
        }
    }
    dashboardIndex = 3;
    reviewPageIndex = 4;
    componentDidUpdate = (prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) => {
        if (this.state.stepperIndex !== prevState.stepperIndex) window.scrollTo({ top: 0, behavior: "instant" });
        if (this.state.stepperIndex == 1 && prevState.stepperIndex == 0) {
            const checkboxEle = this.props.programContainer.ListOfFormSections[0].ListOfFormSubSections[0].ListOfFormSectionElements[1];
            if (!checkboxEle.Value || checkboxEle.Value != "Y") {
                checkboxEle.Valid = false;
                checkboxEle.Touched = true;
                this.setState({ showError: true, stepperIndex: 0 }, () => {
                    this.errorAlertRef.current?.focus();
                });
            }
        }
        if (prevProps.programContainer !== this.props.programContainer && this.props.programContainer) {
            updateFaviconForApp(this.props.programContainer);
        }
    }

    componentDidMount = async () => {
        this.timer = setInterval(() => {
            CMAUtils.saveCMA(this.props.programContainer, this.props.programContainer.Entity?.status).then(success => {
                if (success)
                    this.displayToast();
            });
            console.log(Date.now(), this.props.programContainer);
            // console.log(this.props.programContainer.AppTitle);
        }, 600000); // 60000ms = 1 minute
        

    }

        

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }


    stepIndicator = () => {
        return (
            <div className="ontario-step-indicator" key="cma_form_component_ontario_step_indicator">
                <div className="ontario-row">
                    <div className="ontario-small-12">
                        <div className="ontario-step-indicator--with-back-button">
                            <button className="ontario-button ontario-button--tertiary"
                                onClick={() => {
                                    this.setState({ stepperIndex: this.dashboardIndex, fromReview: false });
                                    CMAUtils.saveCMA(this.props.programContainer, this.props.programContainer.Entity?.status).then(success => {
                                        if (success)
                                            this.displayToast();
                                    });
                                }}>
                                <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-chevron-left"></use>
                                </svg>{this.props.isEng ? "Back to dashboard" : "Retour au tableau de bord"}
                            </button>
                            <span className="ontario-h4">{this.stepIndicatorTitle(this.state.stepperIndex)}</span>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );
    }

    stepIndicatorTitle = (sectionIndex: number) => {
        if (sectionIndex == this.reviewPageIndex) return "";
        let title = "";
        const categoryOrder = sectionIndex - this.reviewPageIndex;
        const funcList = this.props.programContainer.CMATemplateList.filter(t => t.Name == this.props.programContainer.Template)[0].Functions;
     
        let firstCategory = 1;
        funcList.forEach(f => {
            const firstOfNext = firstCategory + f.CategoryDetailList.length;
            if (firstCategory <= categoryOrder && categoryOrder < firstOfNext) {
                if (this.props.isEng) title = "Step " + String(categoryOrder - firstCategory + 1) + " of " + f.CategoryDetailList.length;
                else title = "Étape " + String(categoryOrder - firstCategory + 1) + " de " + f.CategoryDetailList.length;
            }
            firstCategory = firstOfNext;
        });
        return title;
    }

    downloadCSV = () => {
        let csvData = "Template,Assessment name,Status,Organization,Date issued,Overall score\r\n";
        let assessmentList = this.state.CSDAssessments;
        if (this.state.assessmentListOption == "Action required") {
            assessmentList = this.state.CSDAssessments.filter((a) => a.status == TemplateStatus.SUBMITTED);
        }
        assessmentList.forEach((a) => {
            csvData += a.template + ",";
            csvData += a.assessmentName + ",";
            csvData += (a.status == TemplateStatus.SUBMITTED ? "Approved & OPS Submitted" : a.status) + ",";
            csvData += a.organizationName + ",";
            csvData += formatDateCustom(a.createdDate) + ",";
            csvData += (a.score || "N/A") + "\r\n";
        })

        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", "report.csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    
    findOverallScore = (template: string, orgId: string, assessmentIndex: number, status: string) => {
        let result = 0;
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls("data/case/" + template + "/" + orgId + "/status/" + status);
        axios.get((api), {
            withCredentials: true,
            headers: headers
        }).then(response => {
            const rawFormValue = response.data.formValue;
            const parsedFormValue = typeof rawFormValue === "string"
                ? CircularJSON.parse(rawFormValue)
                : rawFormValue;
            let scoreSum = 0;
            let questionsCount = 0;
            for (let key in parsedFormValue) {
                if (typeof (parsedFormValue[key]) == "object" && parsedFormValue[key]) {
                    questionsCount += Object.keys(parsedFormValue[key]).length;
                    scoreSum = Object.keys(parsedFormValue[key]).reduce((acc, k) => acc + parsedFormValue[key][k]["level"], scoreSum);
                }
            }
            let assessmentList = this.state.CSDAssessments;
            assessmentList[assessmentIndex]["score"] = Math.trunc((scoreSum / questionsCount) * 10) / 10;
            this.setState({ CSDAssessments: assessmentList });
        });
    }

    render() {
        let p = this.props.programContainer;
        const cmaRole = this.props.programContainer.userRole;
        const currentSec = p.ListOfFormSections[this.state.stepperIndex];

        let htmlString = [];


        // back to dashboard breadcrumb
        if (this.state.stepperIndex > this.dashboardIndex && !this.state.showConfirmation) {
            htmlString.push(this.stepIndicator());
        }

        // function title on question page
        if (this.state.stepperIndex >= this.dashboardIndex) {
            if (p.Name != "Cyber Security Maturity Assessment Tool\n" + currentSec?.ENUDescription || p.NameFRA != "Outil d’évaluation de la cybermaturité\n" + currentSec?.FRADescription) {
                p.Name = "Cyber Security Maturity Assessment Tool\n" + currentSec?.ENUDescription;
                p.NameFRA = "Outil d’évaluation de la cybermaturité\n" + currentSec?.FRADescription;
                this.props.callback(p);
            }
        }
        else {
            if (p.Name != "Cyber Security Maturity Assessment Tool" || p.NameFRA != "Outil d’évaluation de la cybermaturité") {
                p.Name = "Cyber Security Maturity Assessment Tool";
                p.NameFRA = "Outil d’évaluation de la cybermaturité";
                this.props.callback(p);
            }
        }

        if (this.state.showConfirmation) {
            htmlString.push(
                <div className="ontario-step-indicator">
                    <div className="ontario-row">
                        <div className="ontario-columns ontario-small-12">
                            <div className="ontario-step-indicator--with-back-button">
                                <button className="ontario-button ontario-button--tertiary"
                                    onClick={() => {
                                        this.setState({ stepperIndex: 2, showConfirmation: false });
                                    }}>
                                    <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                        <use href="#ontario-icon-chevron-left"></use>
                                    </svg>{this.props.isEng ? "Back to CMA HUB" : "Retour au CARREFOUR DES ECM"}
                                </button>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
            );
            htmlString.push(
                <SuccessAlertComponent 
                bodyMsg={this.props.isEng ? "Your approver will be notified, and you will receive a confirmation email shortly." : "La personne responsable de votre approbation en sera informée et vous recevrez un courriel de confirmation dans les plus brefs délais."} 
                title={this.props.isEng ? "Submission Successful." : "Envoi réussi."} 
                isEng={this.props.isEng} Visible={true} field={new FormSectionElements()} />
            );
            return htmlString;
        }
        if (this.state.stepperIndex == this.dashboardIndex) {
            htmlString.push(<CMADashboardComponent programContainer={p}
                isEng={this.props.isEng}
                showCommentStatus={p.Entity.status != TemplateStatus.ASSIGNED && p.Entity.status != TemplateStatus.IN_PROGRESS && cmaRole != "CSD Admin" && cmaRole != "CSM Personal"}
                cmaRole={cmaRole}
                callback={(p) => this.props.callback(p)}
                callbackStepIndex={(i) => this.setState({ stepperIndex: i })}
                callbackValueSaved={() => { this.displayToast() }}
            />);

        } else if (this.state.stepperIndex == this.reviewPageIndex) {
            htmlString.push(<CMAReviewComponent programContainer={p} callback={(p) => this.setState({ showConfirmation: true })} isEng={this.props.isEng}
                callbackStepIndex={(i) => this.setState({ stepperIndex: i, fromReview: true })}
                callbackValueSaved={() => { this.displayToast() }} />);

        } else {
            const checkboxEle = this.props.programContainer.ListOfFormSections[0].ListOfFormSubSections[0].ListOfFormSectionElements[1];
            htmlString.push(
                <ErrorAlertsComponent key="cma_form_component_error_alerts_component"
                    ref={this.errorAlertRef}
                    errorMsgList={this.state.showError && this.state.stepperIndex == 0 ? [checkboxEle] : []}
                    isEng={this.props.isEng} />
            );
            htmlString.push(<Heading1 key="cma_form_component_heading1_key" id="cma-heading1" tabIndex={-1}>{this.props.isEng ? currentSec.ENUTitle : currentSec.FRATitle}</Heading1>);
            currentSec.ListOfFormSubSections.forEach((subsec) => {
                const subsecClone = parseJson(stringifyJson(subsec, this.props.programContainer.CategoryId), this.props.programContainer.CategoryId);
                htmlString.push(<SubSectionComponent key={'sec' + currentSec.Id + 'sub_' + subsec.Id} isEng={this.props.isEng}
                    activeSubSection={subsec}
                    editable={true}
                    callbackGeneratePdf={() => {}}
                    callback={(p) => {
                        if (this.state.fromReview && this.state.subsecBool) {
                            this.setState({ initialSubsec: subsecClone, subsecBool: false });
                        }
                        this.props.callback(p)
                    }}
                    callbackStepIndex={(i) => this.setState({ stepperIndex: i })}
                    callbackValidate={(errors) => this.props.callbackValidate(errors)} />);
            });
        }

        if (this.state.stepperIndex > this.reviewPageIndex && !this.state.fromReview) {
            htmlString.push(
                <button className="ontario-button ontario-button--primary" key="cma_form_component_save_button_div"
                    onClick={() => {
                        const secList = p.ListOfFormSections;
                        let nextIndex = this.state.stepperIndex + 1;
                        // if at last category of function, go back to dashboard
                        // if (this.state.stepperIndex == (secList.length - 1) || secList[nextIndex].ENUTitle.includes("Category 1")) {
                        //     nextIndex = this.dashboardIndex;
                        // }

                        if (cmaRole != "CSD Admin" && cmaRole != "CSM Personal"){
                            CMAUtils.saveCMA(this.props.programContainer, this.props.programContainer.Entity?.status).then((success)=>{
                               if( success) this.displayToast();

                            })
                        }


                        // if at last of category of all functions, go back to dashboard
                        if (this.state.stepperIndex == (secList.length - 1)) {
                            nextIndex = this.dashboardIndex;
                        }
                        this.setState({ stepperIndex: nextIndex }, () => {
                            const heading = document.getElementById('cma-heading1');
                            if (heading) {
                                heading.focus();
                            }
                        });
                    }}>{this.props.isEng ? "Next" : "Suivant"}</button>
            );
        }

        if (this.state.stepperIndex > this.reviewPageIndex && this.state.fromReview) {
            htmlString.push(<>
                <button className="ontario-button ontario-button--primary"
                    onClick={() => {
                        this.setState({ stepperIndex: this.reviewPageIndex, fromReview: false, initialSubsec: null, subsecBool: true });
                    }}>{this.props.isEng ? "Save changes": "[FR]Save changes"}</button>

                <button className="ontario-button ontario-button--tertiary"
                    onClick={() => {
                        if (this.state.initialSubsec) currentSec.ListOfFormSubSections[0] = this.state.initialSubsec;
                        this.setState({ stepperIndex: this.reviewPageIndex, fromReview: false, initialSubsec: null, subsecBool: true });

                    }}>{this.props.isEng ? "Cancel and return" : "[FR]Cancel and return"}</button>
            </>);
        }

        htmlString.push(
            <div key="cma_form_component_toast_div">
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
            </div>
        )

        return htmlString;
    }

    displayToast = () => {
        this.growl?.show({ severity: 'success', summary: this.props.isEng ? 'saved' : 'sauvegardé', detail: this.props.isEng ? 'Data saved' : 'Données sauvegardées'});
    }

}
